export const materials = [
    {
        id: 1,
        name: "7-րդ դաս, ԹՊ-քիմիա,08.08.21 վերջնարդյունքներով+",
        info: "Դիտել",
        file: "../../files/chemistry/materials/1.pdf",
        menuItemId: 4
    },
    {
        id: 2,
        name: "8 դաս Թեմատիկ պլան 21.11.21 — վերջնարդյունքով_Ստ.",
        info: "Դիտել",
        file: "../../files/chemistry/materials/2.pdf",
        menuItemId: 4
    },
    {
        id: 3,
        name: "8-րդ դաս․ Ուսուցչի համար, Դասի պլան",
        info: "Դիտել",
        file: "../../files/chemistry/materials/3.pdf",
        menuItemId: 4
    },
    {
        id: 4,
        name: "Աշակերտի համար - Լաբորատոր աշխ. տետր  Քիմիա 8-րդ դասարան",
        info: "Դիտել",
        file: "../../files/chemistry/materials/4.pdf",
        menuItemId: 4
    },
    {
        id: 5,
        name: "Դասի պլանի նմուշ",
        info: "Դիտել",
        file: "../../files/chemistry/materials/5.pdf",
        menuItemId: 4
    },
    {
        id: 6,
        name: "ԹՊ, քիմիա 7, Ք․Բդոյան,  Մ․Գափոյան 2",
        info: "Դիտել",
        file: "../../files/chemistry/materials/6.pdf",
        menuItemId: 4
    },
    {
        id: 7,
        name: "ԹՊ, քիմիա 7 1",
        info: "Դիտել",
        file: "../../files/chemistry/materials/7.pdf",
        menuItemId: 4
    },
    {
        id: 8,
        name: "Նախագծային աշխատանքների ուղեցույց",
        info: "Դիտել",
        file: "../../files/chemistry/materials/8.pdf",
        menuItemId: 4
    },
    {
        id: 9,
        name: "Ուսուցչի համար - Քիմիա 8-րդ դասարան",
        info: "Դիտել",
        file: "../../files/chemistry/materials/9.pdf",
        menuItemId: 4
    },
    {
        id: 10,
        name: "Քիմիա 7-րդ դասարան",
        info: "Դիտել",
        file: "../../files/chemistry/materials/10.pdf",
        menuItemId: 4
    },


];

